var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-title"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.renderInfo.title))]),_vm._v(" "),_c('div',{staticClass:"sub-title-en"},[_vm._v(_vm._s(_vm.renderInfo.en.toUpperCase()))]),_vm._v(" "),_c('div',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.renderInfo.sub))])])
}
var staticRenderFns = []

export { render, staticRenderFns }